import React from "react";
import "./Errorpage.css";

const ErrorPage = () => {
  return (
    <div className="content">
      <h3>Oppps...........Page not found</h3>
    </div>
  );
};

export default ErrorPage;
